<main class="suppliers-page container">
  <!-- page title -->
  <section class="suppliers-page__title">
    <h1 class="page-title">{{ pageTitle() | translate }}</h1>
  </section>
  <section class="suppliers-page__content">
    @if (usePeopleProfiles) {
      <pwj-solutions-people-browse
        class="suppliers-cards"
        filterType="SUPPLIER"
        noContentMessageKey="suppliers.noSuppliers" />
    } @else {
      <pwj-suppliers-filters
        class="suppliers-filters"
        [pageTitle]="pageTitle()"></pwj-suppliers-filters>
      <pwj-cards-list class="suppliers-cards"></pwj-cards-list>
    }
  </section>
</main>
